<template>
  <van-popup
    v-model="visible"
    :style="{
      width: '90%',
      maxWidth: '340px',
      borderRadius: '12px',
      padding: '0',
      background: '#ffffff',
      maxHeight: '70vh',
    }"
    :overlay="true"
    :close-on-click-overlay="closeOnClickOverlay"
    @click-overlay="handleOverlayClick"
  >
    <div class="agreement-popup">
      <!-- 标题 -->
      <div class="popup-title" v-if="title">{{ title }}</div>

      <!-- 内容区域 - 支持滚动 -->
      <div class="content-wrapper">
        <div class="content-scroll" ref="contentScroll" @scroll="handleScroll">
          <!-- 支持HTML内容 -->
          <div v-if="htmlContent" class="content-html" v-html="content" @click="handleContentClick"></div>
          <!-- 纯文本内容 -->
          <div v-else class="content-text">{{ content }}</div>
        </div>
        <!-- 滚动渐变效果 -->
        <div v-if="showScrollGradient" class="scroll-gradient"></div>
      </div>

      <!-- 按钮区域 -->
      <div class="button-area">
        <van-button
          v-if="showConfirmButton"
          class="confirm-button"
          :color="confirmButtonColor"
          :type="confirmButtonType"
          @click="handleConfirm"
        >
          {{ confirmButtonText }}
        </van-button>
        <div
          v-if="showCancelButton"
          class="cancel-button"
          @click="handleCancel"
        >
          {{ cancelButtonText }}
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Button, Popup } from "vant";

export default {
  name: "AgreementPopup",
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
  },
  data() {
    return {
      showScrollGradient: false,
    };
  },
  props: {
    // 控制显示隐藏
    value: {
      type: Boolean,
      default: false,
    },
    // 标题
    title: {
      type: String,
      default: "软件许可及技术服务合同",
    },
    // 是否启用内容点击功能
    contentClickable: {
      type: Boolean,
      default: false,
    },
    // 内容
    content: {
      type: String,
      default: `
      <!-- 富文本内容，适用于Vue2渲染（如v-html） -->
<div style="font-family: '微软雅黑', Arial, sans-serif; font-size: 15px; color: #222; line-height: 1.8;">
  <h2 style="text-align: center;">大模型及算法备案信息公示</h2>
  <p>亲爱的用户，欢迎您使用金声玉亮产品及服务！</p>
  <p>金声玉亮产品及服务由上海亿熵智能科技有限公司、北京未来级数科技有限公司及其关联公司（以下简称“我们”或“金声玉亮”）共同所有和负责运营。</p>
  <p>我们提供的生成式人工智能产品和服务以金声玉亮大语言模型为基础。金声玉亮大语言模型架构基于先进的 Transformer，这一架构以其强大的并行计算能力和灵活的序列建模能力，为模型处理复杂语言任务奠定了基础。在训练过程中，选用英伟达 A800 作为 GPU，训练框架采用 PyTorch，其动态计算图和丰富的库函数，为模型的开发和调试带来了极大的便利，也使得模型能够更好地适应不同的硬件环境和任务需求。</p>

  <h3>金声玉亮模型及算法备案的公示信息如下：</h3>
  <table border="1" cellspacing="0" cellpadding="8" style="border-collapse: collapse; width: 100%; margin: 12px 0;">
    <thead style="background: #f5f5f5;">
      <tr>
        <th>备案类型</th>
        <th>备案名称</th>
        <th>备案号</th>
        <th>公示链接</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>生成式人工智能服务备案</td>
        <td>金声玉亮</td>
        <td>Shanghai-JinShengYuLiang-202503260042</td>
        <td><a href="https://jswx.gov.cn/csj/sh/202504/t20250425_3562055.shtml" target="_blank">备案地址</a></td>
      </tr>
      <tr>
        <td>深度合成服务算法备案</td>
        <td>金声玉亮大模型算法</td>
        <td>网信算备310104666296401240017号</td>
        <td><a href="https://www.cac.gov.cn/2024-08/05/c_1724541639039621.htm" target="_blank">备案地址</a></td>
      </tr>
    </tbody>
  </table>
  <h2 style="text-align: center;">软件许可及技术服务合同</h2>
<p>甲方： 北京未来级数科技有限公司<br>乙方： 用户</p>
<p>(在本合同中，乙方、甲方单独称 “一方”，合称 “双方”)</p>

<p>鉴于：</p>
<p>甲方作为专业的大数据供应、软件开发以及软件服务提供商，拥有软件[“软件”]的所有权利并有能力提供相应的数据库与数据服务[“数据服务”]，能够提供其所自主开发并拥有的软件许可升级、安装、调试、维护、增强和使用培训服务以及提供相应的数据。</p>
<p>乙方因自身需要，同意按照本合同约定，向甲方定购使用该软件，并接收甲方加工、整理和传送的数据使用端口。</p>
<p>以本合同的条款和条件为前提，甲方同意向乙方授予软件的许可，并向乙方提供其所定购的数据。为了维护甲乙双方的正当权益，根据相关法律法规，在平等自愿的基础上，经甲乙双方协商一致，特订立此合同，共同遵守。</p>

<h3>定义</h3>
<p>在本合同中，除非另有定义或上下文另有要求，下列术语有以下含义：</p>
<ul>
  <li>“软件”：指甲方提供给乙方的所有计算机程序以及该等程序的所有更新版本。</li>
  <li>“数据服务”：指甲方整理加工并及时传送给乙方的所有数据以及数据的更新，其中也包括第三方的数据与数据传送服务。</li>
  <li>“合同”：指本《软件许可及技术服务合同》及所有附件，这些附件为本合同不可分割的组成部分。</li>
  <li>“机密信息”：双方标记为机密的各种商业秘密和机密信息，包括但不限于软件、文件、任何一方在履行本合同期间获得的涉及对方商业、未来产品或计划的任何信息或文件，以及甲方或乙方希望不要随意泄露或防止竞争性使用的信息，或者信息披露方指定为机密的信息。</li>
  <li>“增强”：因软件的技术或需求缺陷而对原版本的更新与修改。</li>
  <li>“故障”：软件整体或部分发生故障，不符合其技术规范。</li>
  <li>“人民币”：指人民币，中国的法定货币。</li>
</ul>

<h3>软件许可升级及数据服务</h3>
<ol>
  <li><strong>定购：</strong>根据本合同的条款与条件，乙方向甲方定购《采购订单及补充协议》所列的产品和服务。</li>
  <li><strong>授予软件许可：</strong>根据本合同的条款与条件，甲方在此同意授予并且乙方同意接受一份非独家性的软件使用许可，以便乙方在本合同约定期限内为其业务用途使用软件，并且接受软件的调试、维护、增强等服务内容。未经甲方事先书面同意，乙方不得将使用许可转移或授权给乙方之外的任何第三方。如果乙方未经甲方事先书面同意转移或授权给乙方之外的任何第三方使用，甲方有权立即解除本合同。</li>
  <li><strong>授予数据服务：</strong>根据本合同的条款与条件，甲方在此同意授予并向乙方传送该软件所需要的非独家性的数据，以便乙方在本合同约定期限内为其业务用途使用。</li>
  <li><strong>限制：</strong><br>
    （1）未经甲方事先书面同意，乙方不得对软件的任何部分进行修改、翻译、反向工程、反编译、反汇编或基于此软件或文件制造派生产品；也不得删除此软件或文件上的任何所有权声明或标签。<br>
    （2）乙方订购甲方软件的使用地域及网络出口均限于中国大陆地区内（港澳台、海外除外）。<br>
    （3）乙方使用和利用甲方软件或数据不能损害甲方的利益和业务模式，如甲方发现乙方违反此条款，甲方有权立即解除本合同，不退还乙方已支付的费用。<br>
    （4）乙方应限制在指定安装的机器上通过甲方提供的软件界面查询或提取数据，禁止通过第三方或乙方自己开发的插件或其它工具提取数据。<br>
    （5）在使用过程中乙方接受并遵守甲方软件系统的数据下载量限制条件，甲方享有下载量限制条件的最终解释权。</li>
  <li><strong>权利：</strong>甲方声明并保证本合同约定的软件及数据服务的任何资格及所有权益均为甲方或其供应者/提供方的专有财产。</li>
</ol>

<h3>服务</h3>
<ol>
  <li><strong>服务履行：</strong>甲方承诺在本合同约定期限内，优质、高效地履行本合同所规定的服务。</li>
  </ol>
<h3>配合</h3>
  <ol>
  <li>甲方应为乙方提供相关软件产品及相应的技术文档，有责任对乙方相关人员进行管理、操作、使用及技术培训。</li>
  <li>乙方应按甲方要求提供合同所约定的软件产品所需的硬件设备及硬件环境，并有责任为甲方提供便利的工作条件。</li>
  <li>乙方有责任为甲方的实施工作进行内部各部门、各营业部的协调，调动相关资源，配合甲方按进度完成项目实施。</li>
  <li>甲方在对乙方的服务实施工作中如需要与乙方内部网络环境或软件有关系的第三方进行沟通，乙方有责任联系、协调。</li>
  <li>甲方应不定期对软件产品进行自动升级，因乙方网络设置等原因导致升级不成功而出现的软件故障，由乙方负责解决。</li>
  </ol>
  <h3>安装、培训与其他服务</h3>
  <ol>
    <li>
      <strong>安装：</strong>软件应由甲方为乙方进行安装。甲方的安装人员应经过培训，至少能够达到软件当前版本的安装资格要求。安装时应将对乙方正常经营活动所造成的影响降至最低限度，保持现场安全、清洁、有序。完成安装后，甲方应使现场保持清洁，不留下安装完成后不再需要的任何甲方的材料、工具及因安装所产生的垃圾和废物。
    </li>
    <li>
      <strong>培训：</strong>有关软件操作的培训在软件安装之后由甲方向乙方提供，具体时间由甲乙双方另行协商确定。
    </li>
    <li>
      <strong>其它服务：</strong>除在此描述的服务之外，甲方还可以根据乙方的要求并在甲方同意的条件下，向乙方提供其它服务。
    </li>
  </ol>

<h3>其它保证和责任范围</h3>
<ol>
  <li><strong>软件保证：</strong>甲方声明并保证整个软件均符合其技术规范，如果在本合同约定期限内软件有故障，甲方应在收到乙方通知后24个小时内采取适当方式处理。对于非因乙方原因导致的服务中断，甲方将按服务中断时间为乙方免费顺延相同时间的使用期限。</li>
  <li><strong>遵循法律：</strong>甲方保证，在软件及服务授权许可合同约定期限内，均符合所有可适用的法律、法规、规范性文件的要求。</li>
  <li><strong>询问帮助：</strong>在本合同约定期限内，甲方提供及时响应的服务，甲方应在收到乙方的电话询问或请求服务时为乙方提供帮助，答复有关软件的问题；或向专家咨询以获得解决故障的协助；或尽力找出一个临时性的故障解决方案或应急的代替方法。</li>
  <li><strong>数据传输：</strong>甲方尽最大诚信和努力收集及传送数据，甲方不对收集数据的真实性及传输过程中发生的传送错误承担除更正以外的法律责任，甲方不承担因数据错误或者传送错误造成乙方及乙方客户业务所受的直接利益和期待利益损失。</li>
  <li><strong>除外责任：</strong>除上述明示的保证之外，甲方没有明示或暗示同意任何其它保证，包括但不限于甲方提供给乙方的所有信息和数据仅供乙方及乙方客户参考，甲方不承担乙方或乙方客户由此而导致的任何责任，乙方有责任知会其所有使用者。</li>
</ol>

<h3>机密信息</h3>
<ol>
  <li><strong>信息获取及保护：</strong>在本合同约定期限内，甲方和乙方均可能知晓对方的机密信息（包括但不限于本合同及附件、公司计划、运营活动、财务信息、技术信息、经营信息）。除法律规定及合同另有特别约定外，未经信息提供方书面同意，双方当事人及双方的管理人员、雇员及代理商，都应严格保守对方的机密信息，并采取必要措施以防止机密信息未经授权即被泄露、复制或使用。</li>
  <li><strong>归还：</strong>收到机密信息的一方在收到披露方的请求后，应立即将占有或控制（如有）的所有披露方机密信息归还给披露方，如果本合同根据规定被解除或终止，则任何一方须自行归还、销毁或删除从对方获取的信息、文件和软件等载体。</li>
  <li><strong>保密：</strong>双方的保密义务不因本合同的解除、终止及无效而免除。</li>
  <li><strong>例外：</strong>为履行本合同起见，以下信息不被视为机密信息：在对方收到时已为公众所知的信息；从其它渠道合法获得的信息；遵照有司法管辖权的法院或者其他监管机构的要求必须告知的信息；披露方放弃保密性的信息。</li>
</ol>

<h3>版权</h3>
<ol>
  <li>甲方对合同涉及的软件产品及相关文档、信息拥有独立版权。乙方不得转让/许可第三方使用或者作合同目的以外的使用。</li>
  <li>乙方不得自行复制、仿制甲方相关软件产品。乙方不得自行修改软件。乙方未经许可自行复制、仿制或修改的，由此产生的一切使用中的责任均由乙方承担。</li>
</ol>

<h3>终止</h3>
<ol>
  <li>除以上所述的终止权外，如果任何一方违背了本合同包含或引用的任何重要陈述、担保、合同或义务，若守约方书面通知对方此类严重违约，且违约方在收到此通知后未能在30天内纠正违约事实，则守约方可以提前通知对方终止本合同。本合同自守约方发出该通知之日即行终止，在此情况下，守约方无需承担任何违约或赔偿责任。</li>
</ol>

<h3>违约责任及争议解决</h3>
<ol>
  <li>除本合同特别约定之外，任何一方违反本合同约定的，均应根据相关法律法规向守约方承担违约责任。</li>
  <li>因本合同产生或与此有关的任何争议应首先通过协商解决。如该等争议发生后30日内双方通过友好协商未能解决该等争议，双方同意将该等争议提交有管辖权的人民法院进行解决。</li>
  <li>因乙方原因导致本合同被提前解除，甲方将不退还乙方已经支付的服务费用。</li>
  <li>甲方于本合同项下所应承担的违约责任及过错责任（包括但不限于：违约金、赔偿金、实际损失等），累计不得超过本合同标的金额。</li>
</ol>

 <h3>其他事项</h3>
  <ol>
    <li><strong>通知：</strong>如果通知以书面形式被投递到本合同签字页上所注明的地址，根据本合同，即被视为送达到对方。该地址如有变动，各方应书面形式通知对方。</li>
    <li><strong>标题：</strong>本合同中的所有标题仅作引用之用，且其中包含的词语不得以任何形式被解释、修改、放大或帮助对本合同的条款进行说明、解释或阐明。</li>
    <li><strong>可分割性：</strong>如果本合同的任何条件或条款被有司法管辖权的法院以任何程度禁止或不能执行，合同的其余部分将不受影响，每一条款在法律许可的最大范围内均有效。</li>
    <li><strong>修改：</strong>除非双方的法定代表人或授权签字人签字并加盖公章，任何对本合同的修改或修正以及对合同中任何条款的放弃均被视为无效。</li>
    <li><strong>授权：</strong>甲方和乙方均有全部权利签订并履行本合同。代表双方签订本合同的代表经适当授权，有权签订本合同。</li>
    <li><strong>独立关系：</strong>本合同包含的任何内容均不构成甲方和乙方之间形成合资关系、伙伴关系或者雇佣关系的暗示。任何一方均没有任何权利、特权给对方形成任何义务，不管是明示的还是暗示的，除非本合同另有规定或者双方根据本合同的条款同意。</li>
    <li><strong>不可抗力：</strong>双方均不对因各方合理控制以外的事件而引起的履行义务的延迟或不能履行义务承担责任。此类事件应包括但不限于罢工、暴乱、战争、流行病、公共卫生事件、政府行为、火灾、停电、核事故、地震、异常气候、突发性网络故障、黑客攻击、软件病毒或其它灾难，无论是否与上述事项类似。</li>
  </ol>
  <h3>继续有效</h3>
  <ol>
  <li>本合同所包含的、双方认为其有效时间比本合同期限更长的条件、条款及保证，应在履行完本合同、取消或终止本合同之后继续生效。</li>
  </ol>
  <h3>份数</h3>
  <ol>
    <li>本协议以数据电文的形式体现，不提供纸质协议，乙方本人点击签署合同即生效。本协议保存在甲方指定位置，甲乙双方认可该形式的协议效力及本协议内容。</li>
  </ol>
  <p>（以下无正文）</p>
  <h3>甲方：北京未来级数科技有限公司</h3>
  <p>地址：北京市西城区茶马北街1号院1号楼10层2单元1121</p>
  <h3>乙方：用户</h3>
</div>
`,
      required: true,
    },
    // 是否为HTML内容
    htmlContent: {
      type: Boolean,
      default: true,
    },
    // 是否显示确认按钮
    showConfirmButton: {
      type: Boolean,
      default: true,
    },
    // 确认按钮文案
    confirmButtonText: {
      type: String,
      default: "同意",
    },
    // 确认按钮颜色
    confirmButtonColor: {
      type: String,
      default: "#000000",
    },
    // 确认按钮类型
    confirmButtonType: {
      type: String,
      default: "primary",
    },
    // 是否显示取消按钮
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    // 取消按钮文案
    cancelButtonText: {
      type: String,
      default: "取消",
    },
    // 取消按钮颜色
    cancelButtonColor: {
      type: String,
      default: "#999999",
    },
    // 取消按钮类型
    cancelButtonType: {
      type: String,
      default: "default",
    },
    // 点击遮罩是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: false,
    },
    // 最大高度
    maxHeight: {
      type: String,
      default: "60vh",
    },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.checkScrollability();
    });
  },
  watch: {
    content() {
      this.$nextTick(() => {
        this.checkScrollability();
      });
    },
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.checkScrollability();
        });
      }
    },
  },
  methods: {
    /**
     * 处理内容区域的点击事件
     * 当contentClickable为true时，会触发content-click事件
     * @param {Event} event - 点击事件对象
     */
    handleContentClick(event) {
      if(this.contentClickable) {
        this.$emit("content-click", event);
      }
    },
    handleConfirm() {
      this.$emit("confirm");
      this.visible = false;
    },
    handleCancel() {
      this.$emit("cancel");
      this.visible = false;
    },
    handleOverlayClick() {
      if (this.closeOnClickOverlay) {
        this.$emit("close");
        this.visible = false;
      }
    },
    handleScroll() {
      if (!this.$refs.contentScroll) return;

      const element = this.$refs.contentScroll;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      // 添加5px的容差，避免精度问题
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 5;
      const isScrollable = scrollHeight > clientHeight;

      this.showScrollGradient = isScrollable && !isNearBottom;
    },
    checkScrollability() {
      if (!this.$refs.contentScroll) return;

      const element = this.$refs.contentScroll;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;
      const scrollTop = element.scrollTop;

      // 添加5px的容差，避免精度问题
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 5;
      const isScrollable = scrollHeight > clientHeight;

      this.showScrollGradient = isScrollable && !isNearBottom;
    },
  },
};
</script>

<style lang="less" scoped>
.agreement-popup {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  max-height: 70vh;

  .popup-title {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    text-align: center;
    padding: 20px 16px 0;
    flex-shrink: 0;
    line-height: 1.4;
  }

  .content-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding: 16px 0 0;
    position: relative;

    .content-scroll {
      flex: 1;
      overflow-y: auto;
      padding: 0 16px;
      max-height: 400px;

      .content-text,
      .content-html {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        line-height: 22px;
        color: #4e5969;
        font-size: 15px;
        text-align: left;
        white-space: normal;
        word-break: break-word;
        margin: 0;
        padding: 0;
      }

      .content-html {
        /deep/ p {
          margin: 6px 0;
          line-height: 1.4;
        }

        /deep/ h1,
        /deep/ h2,
        /deep/ h3,
        /deep/ h4,
        /deep/ h5,
        /deep/ h6 {
          margin: 10px 0 6px 0;
          font-weight: 600;
          line-height: 1.3;
        }

        /deep/ ul,
        /deep/ ol {
          margin: 6px 0;
          padding-left: 16px;
        }

        /deep/ li {
          margin-bottom: 8px;
          line-height: 1.4;
        }

        /deep/ table {
          border-collapse: collapse;
          width: 100%;
          margin: 12px 0;
          font-size: 13px;
          display: block;
          overflow-x: auto;
          white-space: nowrap;
        }

        /deep/ table thead,
        /deep/ table tbody,
        /deep/ table tr {
          display: table;
          width: 100%;
          table-layout: fixed;
        }

        /deep/ table th,
        /deep/ table td {
          padding: 8px 6px;
          border: 1px solid #ddd;
          text-align: left;
          vertical-align: top;
          word-wrap: break-word;
          white-space: normal;
          min-width: 80px;
        }

        /deep/ table th {
          background: #f5f5f5;
          font-weight: 500;
          font-size: 12px;
        }

        /deep/ table td {
          font-size: 12px;
          line-height: 1.3;
        }

        /deep/ table th:first-child,
        /deep/ table td:first-child {
          min-width: 120px;
        }

        /deep/ table th:nth-child(2),
        /deep/ table td:nth-child(2) {
          min-width: 100px;
        }

        /deep/ table th:nth-child(3),
        /deep/ table td:nth-child(3) {
          min-width: 140px;
        }

        /deep/ table th:last-child,
        /deep/ table td:last-child {
          min-width: 80px;
        }

        /deep/ table a {
          color: #1890ff;
          text-decoration: none;
          font-size: 11px;
          display: inline-block;
          margin: 1px 0;
        }

        /deep/ table a:hover {
          text-decoration: underline;
        }
      }
    }

    .scroll-gradient {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 24px;
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.3) 30%,
        rgba(255, 255, 255, 0.8) 70%,
        rgba(255, 255, 255, 1) 100%
      );
      pointer-events: none;
      z-index: 1;
      transition: opacity 0.3s ease;
    }
  }

  .button-area {
    flex-shrink: 0;
    padding: 20px 16px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    .cancel-button,
    .confirm-button {
      width: 100%;
      height: 36px;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 400;
      border: none;
      outline: none;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }
    }

    .cancel-button {
      text-align: center;
      font-weight: 400;
      font-size: 16px;
      color: #86909c;
      cursor: pointer;
      padding: 8px 16px;

      &:active {
        color: #646566;
      }
    }

    .confirm-button {
      transition: opacity 0.2s ease;
      /deep/ .van-button {
        background: #000000 !important;
        color: #ffffff !important;
        border: none !important;
      }
    }
  }
}

// 全局覆盖 vant 按钮样式
/deep/ .van-button {
  border: none;
  font-size: 16px;
  font-weight: 400;

  &--default {
    background: #f5f5f5;
    color: #666666;
    border: none;
  }

  &--primary {
    background: #000000;
    color: #ffffff;
    border: none;
  }
}

// 滚动条样式
.content-scroll {
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 2px;

    &:hover {
      background: #cccccc;
    }
  }
}

// 单个按钮时的样式
.button-area:has(.cancel-button:only-child),
.button-area:has(.confirm-button:only-child) {
  .cancel-button,
  .confirm-button {
    flex: none;
    width: 100%;
  }
}
</style>
